import heroImage from "../assets/hero.png";

export default function HeroSection() {
    return (
        <section className="bg-white pt-20 pb-10 px-6">
        <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between gap-10">
          <div className="md:w-1/2 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-primary">Tingkatkan</span> Skill Codingmu<br />
              <span className="underline decoration-yellow-400 decoration-4">dengan Cara Berbeda</span>
            </h1>
            <p className="text-gray-600 mb-6">
              Ikuti kursus online privat agar kamu bisa belajar sesuai gaya dan waktu belajarmu. Nyaman, fleksibel, dan langsung praktik.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <a target="_blank" rel="noreferrer" href="https://wa.me/6288976323341?text=Halo%20min%2C%20saya%20mau%20daftar%20kursus">
                <button className="bg-primary text-white px-6 py-3 rounded-xl font-semibold hover:bg-accent transition">
                  Mulai Sekarang
                </button>
              </a>
             
              {/* <button className="border border-primary text-primary px-6 py-3 rounded-xl font-semibold hover:bg-primary hover:text-white transition flex items-center gap-2">
                ▶ Lihat Video
              </button> */}
            </div>
          </div>
          <div className="md:w-1/2">
            <img src={heroImage} alt="Hero Image" className="w-full h-auto" />
          </div>
        </div>
      </section>
    );
  }
  